import http from "./http-common";

export const getClassifications = (active: number) => http.get(`/user-classifications/${active}`);